/* eslint-disable import/prefer-default-export */

/**
 * Dates represented as strings e.g. 2023-04-20T00:00:00
 * @typedef TableDataCalendar
 * @property {{startDate: string, endDate: string}} firstWeek
 * @property {{startDate: string, endDate: string}} lastWeek
 * @property {string[]} pendingDates
 */

/** @param {unknown} data @returns {TableDataCalendar} */
export const getWeeklyReportCalendarAdapter = (data) => {
  const startDay = `${window.location.pathname.split('/').at(-1)}T00:00:00`;

  return {
    firstWeek: {
      startDate: data.primerSemana?.fechaInicio ?? startDay,
      endDate: data.primerSemana?.fechaFin ?? startDay
    },
    lastWeek: {
      startDate: data.ultimaSemana?.fechaInicio ?? startDay,
      endDate: data.ultimaSemana?.fechaFin ?? startDay
    },
    pendingDates: data.fechasPendientes ?? []
  };
};
